import { Controller } from "stimulus"
import  Cookies  from 'js-cookie'
import {hideWin, hiddenWins, clearHiddenWins}  from '../hideWinCookie'

export default class extends Controller {
  static get targets(){
    return ['line', 'showbtn'];
  }

  initialize(){
    this.toggleLines();
  }

  showToggleBtn(){

    if (hiddenWins().length >  0){
      this.showbtnTarget.style.visibility = 'visible';
    }

    else{
      this.showbtnTarget.style.visibility = 'hidden';
    }

  }

  skip(e){
    let target_win = e.target.closest("button").id;
    // if(target_win == ""){
    //   target_win = e.target.parentElement.id;
    // }

    hideWin(target_win);
    this.toggleLines();
  }


  toggleLines(){
    this.lineTargets.forEach(function(d, i) {
      if (hiddenWins().includes(d.id)){
        d.style.display = 'none';
      }
      else {
        d.style.display = 'table-row';
      }
    });
    this.showToggleBtn();
  }

  showLines(){
    this.clearCookie();
    this.toggleLines();
  }

  clearCookie(){
    clearHiddenWins();
  }

}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/hide_intake_items_controller.js